export const selectBalanceState = state => state.balance;
export const selectPaymentMethods = state => state.balance.paymentMethods;
export const selectBalanceIsLoading = state => state.balance.isLoading;
export const selectBalanceError = state => state.balance.error;
